import type { Lottery } from '@lotta/shared/types-lottery-schemas';
import type { Expand } from '@lotta/shared/util-utilities';
import { DateTime } from 'luxon';

type RequiredLotteryProps = Expand<
  Pick<Lottery, 'lotteryStatus'> & {
    occurrence: Pick<Lottery['occurrence'], 'startDate'>;
  }
>;

/**
 * Stop Lottery
 *
 * Possible between first signup period start until last draw is made.
 */
export const isStopLotteryAllowed = (
  lottery: RequiredLotteryProps,
  timezone: string,
  date: Date
) => {
  switch (lottery.lotteryStatus) {
    case 'ONGOING':
      return true;
    case 'PENDING': {
      // Allowed if signup have started
      const startDate = DateTime.fromISO(lottery.occurrence.startDate, { zone: timezone }).startOf(
        'day'
      );
      return startDate.toJSDate() <= date;
    }
    default:
      return false;
  }
};
